(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('PerformanceController', PerformanceController);

    PerformanceController.$inject = ['pagingParams', '$state'];

    function PerformanceController(pagingParams, $state) {

        var vm = this;
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.fleet = {};
        vm.objectType = {};
        vm.selectedFleets=[];
        vm.selectedCondition = {};
        vm.transition = transition;
        vm.applyFilter = applyFilter;

        function applyFilter(fleet, objectType) {
            if (fleet.id) {
                if (fleet.id > 0)
                    vm.fleet = fleet;
                else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                }
            }
            if (objectType.id)
                vm.objectType = objectType;
            else
                vm.objectType.id = -1;
            vm.transition();
        }

        function transition(notify) {
            $state.transitionTo($state.$current, {
                objectType: vm.selectedObjectType.id,
                fleet: vm.selectedFleet.id
            }, {notify: false, location: "replace"});
        }

    }
})();


